import { FilterObject, FilterValue } from 'components/filtering/types/FilterObject';
import { getObjectEntries, containsKeys } from '@utils/typescriptGuards';



export const createFilterObject = <T extends object>(originData: Array<T> | null | undefined): FilterObject<T> | null => {
	if (!originData || originData.length === 0) return null;

	let newFilterObject: Partial<FilterObject<T>> = {};

	
	originData.map((originItem, originItemIndex) => {

		getObjectEntries(originItem).map(([entryKey, entryValue], entryIndex) => {
			
			if (newFilterObject[entryKey] === undefined || newFilterObject[entryKey] === null) {
				newFilterObject[entryKey] = [];
			}

			let newFilterValue: FilterValue = {
				id: `${String(entryKey)}:${originItemIndex}:${entryIndex}`,
				value: entryValue,
				checked: true,
				hidden: false,
				rowIndex: originItemIndex,
				columnIndex: entryIndex,
			}

			let filterValues = newFilterObject[entryKey];
			if (filterValues !== null && filterValues !== undefined) {
				filterValues.push(newFilterValue);
			}
		})
	})


	if (originData[0] && containsKeys(newFilterObject, Object.keys(originData[0]))) {
		return newFilterObject;
	}
	
	return null;
};